<template>
    <b-modal ref="copied" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('copied')}}</h3>
      </div>
      <p>{{$ml.get('selectedtextcopied')}}</p>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="msstreamblue" block @click="cleanMyTimeout();$refs.copied.hide()">Ok</b-btn>
      </b-row>
    </b-modal>
</template>

<script>
    export default {
        data: function() {
            return {
                timeout: null,
            }
        },
        methods: {
            cleanMyTimeout() {
            try {
                clearTimeout(this.timeout);
            } catch(err) {}
            },
            copyToClipboard(text) {
                this.cleanMyTimeout();
                this.$copyText(text);
                this.$refs.copied.show();
                this.timeout = setTimeout(this.$refs.copied.hide, 1.5 * 1000, 'copied');
            },
        }
    }
</script>